import { render, staticRenderFns } from "./Detail7.vue?vue&type=template&id=ae35fc72&scoped=true&"
import script from "./Detail7.vue?vue&type=script&lang=js&"
export * from "./Detail7.vue?vue&type=script&lang=js&"
import style0 from "./Detail7.vue?vue&type=style&index=0&id=ae35fc72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae35fc72",
  null
  
)

export default component.exports